import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { authActions, getAuth } from 'src/auth';
import { Button } from 'react-bootstrap';
import SignInForm from '../../components/sign-in-form';
import './sign-in-page.css';

export class SignInPage extends Component {

  constructor() {
    super(...arguments);
  }

  render() {
    return (
      <div className="g-row sign-in">
        <div className="g-col">
          <h1 className="sign-in__heading">Sign in</h1>
          <Button 
            bsStyle="primary" 
            className='sign-in-btn' 
            onClick={this.props.signInWithGithub}
          >
            GitHub
          </Button>
          <Button 
            bsStyle="primary" 
            className='sign-in-btn' 
            onClick={this.props.signInWithGoogle}
          >
            Google
          </Button>
          <Button 
            bsStyle="primary" 
            className='sign-in-btn' 
            onClick={this.props.signInWithTwitter}
          >
            Twitter
          </Button>
          <SignInForm 
            loginError={this.props.loginError} 
            signInWithEmailAndPassword={this.props.signInWithEmailAndPassword}
            clearError={this.props.clearError}
          />
        </div>
      </div>
    );
  }
}

SignInPage.propTypes = {
  signInWithGithub: PropTypes.func.isRequired,
  signInWithGoogle: PropTypes.func.isRequired,
  signInWithTwitter: PropTypes.func.isRequired,
  signInWithEmailAndPassword: PropTypes.func.isRequired
};


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = getAuth;

const mapDispatchToProps = {
  signInWithGithub: authActions.signInWithGithub,
  signInWithGoogle: authActions.signInWithGoogle,
  signInWithTwitter: authActions.signInWithTwitter,
  signInWithEmailAndPassword: authActions.signInWithEmailAndPassword,
  clearError: authActions.clearError,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SignInPage)
);



// WEBPACK FOOTER //
// ./src/views/pages/sign-in/sign-in-page.js